/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import React from "react";

export const NoteEditSVG: React.FC = () => {
  return (
    <svg
      width="80"
      height="90"
      viewBox="0 0 123 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="svg-root ms-ac-referenceview-app-note-edit"
    >
      <path
        d="M103.036 81.6861C85.202 90.7398 62.7524 98.2708 44.707 106.637C43.6988 107.146 42.4665 106.793 41.7432 105.702C29.8782 87.5643 22.5518 47.9541 20.9483 38.1454C20.6922 36.8463 21.4092 35.6552 22.5038 35.2279L80.4713 13.0239C81.8796 12.487 83.3967 13.435 83.6719 14.9961C85.5412 25.1374 92.3138 58.2898 104.041 77.8413C104.784 79.1943 104.352 80.9801 103.036 81.6861Z"
        fill="url(#paint0_radial)"
      />
      <path
        d="M73.8846 96.5303L71.3433 101.36C70.9944 102.086 71.2184 102.949 71.817 103.434C72.4891 103.826 73.2765 103.596 73.7118 102.951L76.2531 98.1214L73.8846 96.5303Z"
        fill="#3E8EED"
      />
      <path
        d="M74.2846 85.5291L71.3624 99.4275L75.4081 101.955L84.8309 92.2577L74.2846 85.5291Z"
        fill="#FFE5B9"
      />
      <path
        d="M116.223 35.5566L87.3594 91.6424C86.8633 92.5548 85.8359 92.8018 84.9973 92.3334L74.0446 85.5452C73.1996 84.9895 72.9564 83.8651 73.3725 82.9583L102.236 26.8725C104.342 22.6877 109.226 21.2946 113.019 23.6645C116.978 26.1106 118.329 31.3718 116.223 35.5566Z"
        fill="#FFD590"
      />
      <path
        d="M77.9178 73.1608L74.29 80.21L89.094 89.4443L92.7218 82.3951L77.9178 73.1608Z"
        fill="#F7B548"
      />
      <path
        d="M80.693 67.7383L79.3667 70.3154L94.1707 79.5497L95.497 76.9726L80.693 67.7383Z"
        fill="#F7B548"
      />
      <path
        d="M77.9847 46.0289L42.5308 59.3806C40.8088 60.0271 38.8852 59.0196 38.2643 57.1315C37.6433 55.2433 38.5363 53.162 40.2583 52.5155L75.7122 39.1638C77.4342 38.5173 79.3578 39.5248 79.9787 41.413C80.5996 43.3012 79.7067 45.3824 77.9847 46.0289Z"
        fill="white"
      />
      <path
        d="M67.5185 67.8259L47.8824 75.3369C46.1604 75.9834 44.2368 74.9759 43.6159 73.0877C42.9949 71.1995 43.8879 69.1183 45.6099 68.4718L65.246 60.9608C66.968 60.3143 68.8916 61.3218 69.5125 63.21C70.1335 65.0982 69.2405 67.1794 67.5185 67.8259Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(90.4984 102.621) rotate(-3.97846) scale(40.9047 44.6619)"
        >
          <stop offset="0.00065331" stopColor="#3E8EED" />
          <stop offset="1" stopColor="#72ACF1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
